import infomation from './infomation.vue'
const diy_infomation = {
    install: function (Vue) {
        Vue.component('diy_infomation', infomation)
    }
};
// 导出组件
export default diy_infomation